module.exports = __webpack_public_path__ + "img/case_two.4dbc075d.png";